export const nistCsfFunctions = [
  {
    id: 'govern',
    label: 'GOVERN',
    desc: 'Establish and monitor cybersecurity risk strategy, expectations, policy, and accountability.',
    guidance: 'Govern anchors the CSF by defining how cybersecurity risk is understood, communicated, overseen, and aligned to organizational objectives.',
    principles: [
      'Define cybersecurity risk management strategy and accountability',
      'Maintain policies, roles, oversight, and decision criteria',
      'Track risk posture and communicate priorities to stakeholders'
    ],
    capabilities: [
      'Executive summaries',
      'Tenant reporting',
      'Risk trend dashboards',
      'Compliance mapping'
    ],
    outcomes: [
      'Leadership can see security posture across tenants and programs',
      'Security priorities are connected to operational risk',
      'Evidence is easier to prepare for internal review and audits'
    ]
  },
  {
    id: 'identify',
    label: 'IDENTIFY',
    desc: 'Develop an organizational understanding to manage cybersecurity risk to systems, assets, data, and capabilities.',
    guidance: 'Identify focuses on asset context, business environment, dependencies, and risk assessment so teams know what they are protecting and where exposure exists.',
    principles: [
      'Maintain visibility into assets, services, users, and dependencies',
      'Understand exposure across cloud, SaaS, network, and code surfaces',
      'Prioritize risk based on business and technical context'
    ],
    capabilities: [
      'External attack surface discovery',
      'Asset inventory enrichment',
      'Certificate monitoring',
      'SaaS domain coverage'
    ],
    outcomes: [
      'Unknown assets and shadow services are easier to find',
      'Teams can prioritize exposed systems with better context',
      'MSPs can track tenant risk consistently'
    ]
  },
  {
    id: 'protect',
    label: 'PROTECT',
    desc: 'Develop and implement safeguards to help ensure delivery of critical services.',
    guidance: 'Protect covers preventive safeguards, secure configuration, access discipline, awareness, and data protection activities that reduce the likelihood or impact of incidents.',
    principles: [
      'Reduce risk before deployment through secure engineering checks',
      'Harden infrastructure and application configurations',
      'Protect sensitive data and dependency integrity'
    ],
    capabilities: [
      'SAST and Semgrep scanning',
      'IaC configuration scanning',
      'Supply chain security and SBOM',
      'Hardcoded secrets detection'
    ],
    outcomes: [
      'Unsafe defaults and insecure code paths are found earlier',
      'Teams can reduce preventable production exposure',
      'Dependency and configuration risks become visible before release'
    ]
  },
  {
    id: 'detect',
    label: 'DETECT',
    desc: 'Develop and implement activities to identify the occurrence of a cybersecurity event.',
    guidance: 'Detect emphasizes continuous monitoring, anomaly discovery, event analysis, and signal correlation across the environment.',
    principles: [
      'Monitor events across code, infrastructure, and network layers',
      'Correlate signals to reduce noise and improve confidence',
      'Surface anomalies and suspicious activity quickly'
    ],
    capabilities: [
      'Network analysis',
      'Global threat intelligence',
      'Taint tracking',
      'Exposure detection'
    ],
    outcomes: [
      'Suspicious traffic and vulnerable paths are easier to spot',
      'Security teams can move from raw alerts to richer context',
      'Threat intelligence supports faster prioritization'
    ]
  },
  {
    id: 'respond',
    label: 'RESPOND',
    desc: 'Develop and implement activities to take action regarding a detected cybersecurity incident.',
    guidance: 'Respond turns detection into coordinated analysis, communication, containment, mitigation, and improvement activities.',
    principles: [
      'Triage alerts with context and severity',
      'Coordinate incident response and containment actions',
      'Use repeatable playbooks to reduce response time'
    ],
    capabilities: [
      'SOAR automation',
      'Incident response framework',
      'Alert triage',
      'Automated playbooks'
    ],
    outcomes: [
      'Analysts can act from a shared operational view',
      'Response actions become more consistent and repeatable',
      'High-risk events can be escalated with better supporting evidence'
    ]
  },
  {
    id: 'recover',
    label: 'RECOVER',
    desc: 'Develop and implement activities to maintain resilience and restore capabilities or services impaired by incidents.',
    guidance: 'Recover supports restoration planning, lessons learned, communications, and continuous improvement after security events.',
    principles: [
      'Track remediation and restoration activities',
      'Capture lessons learned from incidents and findings',
      'Improve resilience through reporting and trend analysis'
    ],
    capabilities: [
      'Remediation tracking',
      'Tenant reporting',
      'Continuous improvement',
      'Compliance tracking'
    ],
    outcomes: [
      'Teams can monitor remediation progress after incidents',
      'Repeat issues become visible through trends',
      'Recovery planning is supported by clearer evidence and reporting'
    ]
  }
];

export default nistCsfFunctions;
